import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { siteActions } from "../../../redux/actions/siteActions";
import ViewSiteList from "./ViewSiteList";
import { alertsActions } from "../../../redux/actions/alertsActions";

const mapStateToProps = state => {
  return {
    siteList: state.siteReducer.siteList,
    siteData: state.siteReducer.siteData,
    deleteSiteStatus: state.siteReducer.deleteSiteStatus,
    siteStatusResponse: state.siteReducer.siteStatusResponse,
    error: state.siteReducer.error,
    siteResponse: state.siteReducer.siteResponse,
    siteEditResponse: state.siteReducer.siteEditResponse,
    alertType: state.alertsReducer.alertType,
    message: state.alertsReducer.message,
    domainStatus: state.siteReducer.domainStatus,
    domainList: state.siteReducer.domainList,
    ssl: state.siteReducer.ssl,
  };
};

const mapDispatchToProps = dispatch => {
  return {
    actions: bindActionCreators(
      {
        ...siteActions,
        ...alertsActions
      },
      dispatch
    )
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(ViewSiteList);



// WEBPACK FOOTER //
// ./src/app/views/manageSite/viewSiteList/index.js